import usercategories from "../../data/usersCategories.json";
import { Button } from '../../layouts/ui/Button';
export const JobSeekerPage = () => {

  return (
    <section className="mt-10 w-full max-w-[1312px] bg-gradient-to-r from-[#ECF1FF] to-[#EED8FF] rounded-t-xl px-4">
      <div className='  my-10'>
        <div className='text-[#454545]'>
          <h2 className="text-2xl sm:text-3xl lg:text-[36px] font-bold text-center">
            For Job Seekers
          </h2>
          <h4 className="text-lg sm:text-xl lg:text-[18px] font-semibold text-center">
            Your Career, Simplified
          </h4>
        </div>
        {/* Cards */}
        <div className="flex justify-center gap-6 mt-10 flex-wrap">
          {usercategories?.HowJobSeekers &&
            usercategories?.HowJobSeekers.map((user, index) => (
              <div
                key={index}
                className="bg-white rounded-[12px] w-full sm:w-[220px] md:w-[250px] px-6 py-5 space-y-2 h-[330px] shadow-sm flex flex-col"
              >
                <div className='flex justify-center'>
                  <div className={`bg-gradient-to-r  ${index % 2 === 0 ? "from-[#9747FF] to-[#0051F8]" : "from-[#56AB2F] to-[#A8E063]"} rounded-xl p-2 w-10 h-10 flex justify-center items-center`}>
                    <img
                      src={user?.icon}
                      alt={user.heading}
                      className="w-6 h-6 sm:w-auto sm:h-auto"
                    />
                  </div>
                </div>

                <h3 className="font-semibold text-base sm:text-lg text-center md:text-left">
                  {user.Heading}
                </h3>
                <p className="text-sm text-gray-600 text-center md:text-left">
                  {user?.subHeading}
                </p>
                <ul className="list-disc pl-5 space-y-1 text-[14px] text-gray-600">
                  {user.Listing.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
        </div>

        <div className="flex justify-center my-5">
          <Button
            className="w-[200px] h-[48px] bg-white border border-[#2C25C4] text-[#2C25C4] rounded-[8px]"
            children={`Browse a Job Today`}
            onClick={() => window.location.href = '/signup'}
          />
        </div>
        <div className='bg-gray-300 w-full h-[0.5px]'></div>
      </div>
    </section>
  )
}
